import httpClient from './http-client';

const endpoint = 'api/articles';

const articlesService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (article) => httpClient.post(`${endpoint}`, article),

  update: (article) => httpClient.put(`${endpoint}/${article.id}`, article),

  reorder: (payload) => httpClient.post('api/articles-reorder', payload),

  delete: (article) => httpClient.delete(`${endpoint}/${article.id}`),
};

export default articlesService;
